import { Box, Flex } from "@chakra-ui/react";
import helpSvg from "../assets/help.svg";
import { Modal, ModalOverlay, ModalContent, ModalCloseButton, ModalBody, useDisclosure } from "@chakra-ui/react";


export const HelpModal = ({children, ...props}) => {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
        <Flex className="help_modal_trigger_container" justify="end" marginBottom="10px" >
            <Box className="help_modal_trigger" onClick={onOpen} cursor="pointer" as="img" src={helpSvg} width="25px"/>
        </Flex>

        <Modal className="help_modal" isOpen={isOpen} onClose={onClose}>
            <ModalOverlay/>
            <ModalContent fontSize="0.8rem" {...props}>
                <ModalCloseButton />
                <ModalBody marginTop="30px">
                    {children}
                </ModalBody>
            </ModalContent>
        </Modal>
        </>
    )
}


export const TrendHelpModal = ({...props}) => {

    return (
        <HelpModal {...props}>
            <Box textAlign="center" fontWeight="bold" marginBottom="5px">Summary Info</Box>
            <Paragraph>
                <Name className="name">Frequency: </Name><Detail className="meaning">This is the total number of times a number is selected in the given period</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Avg Misses: </Name><Detail className="meaning">This is the average number of successive times a number was not selected in the given period</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Max Misses: </Name><Detail className="meaning">This is the highest number of successive times a number was not selected in the given period</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Max Hits: </Name><Detail className="meaning">This is the highest number of successive times a number was selected in the given period</Detail>
            </Paragraph>
        </HelpModal>
    )
}


export const StatsHelpModal = ({...props}) => {

    return (
        <HelpModal {...props}>
            <Box textAlign="center" fontWeight="bold" marginBottom="5px">Stats Info</Box>
            <Paragraph>
                <Name className="name">Sum: </Name><Detail className="meaning">This is the summation of all the results</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Range: </Name><Detail className="meaning">This is the range of values of the results. (Highest value - Lowest value)</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Pattern: </Name><Detail className="meaning">This shows the pattern in which the numbers follow in terms of various number categories</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Ratio: </Name><Detail className="meaning">This is the ratio of the number category being compared </Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Prime Pattern abbreviation: </Name><Detail className="meaning">P - Prime number, C - Composite number</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Size Pattern abbreviation: </Name><Detail className="meaning">S - Small number (number &lt; 45), B - Big number (number &gt; 45)</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Parity Pattern abbreviation: </Name><Detail className="meaning">E - Even number, O - Odd number</Detail>
            </Paragraph>
            <Paragraph>
                <Name className="name">Prime Pattern abbreviation: </Name><Detail className="meaning">P - Prime number, C - Composite number</Detail>
            </Paragraph>
        </HelpModal>
    )
}







const Paragraph = ({children, ...props}) => {
    return (
        <Box
            marginBottom="10px"
        >
            {children}
        </Box>
    )
}

const Name = ({children, ...props}) => {
    return (
        <Box
            as="span"
            fontWeight="bold"
        >
            {children}
        </Box>
    )
}

const Detail = ({children, ...props}) => {
    return (
        <Box
            as="span"
        >
            {children}
        </Box>
    )
}